import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IService } from '../../../models/index';
import { ICreateServiceState } from '../../actions/types/services/CreateUpdatedServiceTypes';

/**
 * Initial Service state in store
 */
const initialState: ICreateServiceState = {
  isLoading: false,
  errorMessage: '',
  success: false,
  serviceData: {} as IService
};

/**
 * Create Service Slice to create new Service
 */
const createServiceSlice = createSlice({
  name: 'createService',
  initialState,
  reducers: {
    createServiceStarted: (state) => {
      state.isLoading = true;
    },

    createServiceSuccess: (
      state,
      action: PayloadAction<IService>
    ) => {
      state.isLoading = false;
      state.serviceData = action.payload;
      state.success = true;
      state.errorMessage = '';
    },

    createServiceFail: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.serviceData = initialState.serviceData;
      state.success = false;
      state.errorMessage = action.payload;
    },

    clearServiceDetails: (state) => {
      state.isLoading = false;
      state.serviceData = initialState.serviceData;
      state.errorMessage = '';
      state.success = false;
    }
  }
});

export const {
  createServiceStarted,
  createServiceSuccess,
  createServiceFail,
  clearServiceDetails
} = createServiceSlice.actions;
export default createServiceSlice.reducer;
